/**
 * 根据姓名或昵称排序,
 * 维护两个数组,分别存入字母开头和数字符号开头的项
 * 这里如果想把数字符号开头的名字排在最前面,就只用一个w_users就可以了,排序的时候会默认在最前面
 * @param  {Array} list 需要排序的数组对象,格式类似上面效果中的数据
 * @return {Array} sort_list 排序后的数组对象
 */
import pinyin from "pinyin";

function nameSort(list) {
  let w_users = []; //字母开头
  let n_users = []; //数字 or 符号

  list.forEach((item) => {
    let first_word = pinyin(item.name, {
      style: pinyin.STYLE_FIRST_LETTER,
      heteronym: true,
    });

    if (first_word[0].length > 1) {
      if (first_word[0][1] == "a") {
        first_word = first_word[0][1];
      } else {
        first_word = first_word[0][0];
      }
    } else {
      first_word = first_word[0][0];
    }
    first_word = first_word.substr(0, 1);

    item.name_sort = first_word + item.name; //增加一个临时排序属性, 不然排序后还要处理原属性
    let regx = /^[A-Za-z]*$/; //正则匹配出字母开头的
    let flag = regx.test(first_word);
    (flag && w_users.push(item)) || n_users.push(item); //根据类型决定存入哪个数组
  });

  //利用新增的name_sort排序
  w_users.sort(
    (a, b) =>
      a.name_sort.substr(0, 1).toLowerCase().charCodeAt(0) -
      b.name_sort.substr(0, 1).toLowerCase().charCodeAt(0)
  );
  n_users.sort(
    (a, b) =>
      a.name_sort.substr(0, 1).toLowerCase().charCodeAt(0) -
      b.name_sort.substr(0, 1).toLowerCase().charCodeAt(0)
  );
  let sort_list = w_users.concat(n_users);
  return sort_list;
}

export default nameSort;
